<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <label for="editAnswer" class="form-label">{{ _t('Answer') }}</label>
                <input v-model="text" type="text"  class="form-control"/>
            </div>
            <div class="col-lg-3 col-md-6">
                <label for="sortOrder" class="form-label">{{ _t('Sort order') }}</label>
                <input v-model="sort_order" type="number" id="sortOrder" class="form-control"/>
            </div>


        </div>
        <div class="row" style="margin-top: 0.75em">
            <div class="col-md-3">
                <button :disabled="isSurveyActive" @click="addAnswer" class="btn btn-primary mt-3">
                    <i class="fa fa-plus"/>
                    {{ _t('Add answer') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateAnswer",
    props: ['questionId', 'isSurveyActive'],
    data() {
        return {
            text: '',
            sort_order: 0,
        }
    },
    methods: {
        addAnswer() {
            this.$emit('add-answer', {
                questionId: this.questionId,
                answer: {text: this.text, sort_order: this.sort_order}
            })

            this.text = '';
            this.sort_order = 0;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/CreateAnswer.vue